export default __webpack_public_path__ + "static/media/smallCap.8a592e51.gif";